import React,{useState} from "react";
import { Card,CardBody,Table,Badge,Button,Row,Col,Input,Modal,ModalHeader,ModalBody,FormGroup,Label } from "reactstrap";
import Select from "react-select";
import { toast } from "react-toastify";

import Breadcrumbs from "../../components/Common/Breadcrumb";

import useFbForms from "../../Hooks/useFbForms";
import useProjects from "../../Hooks/useProjects";
import useProjectFormRelations from "../../Hooks/useProjectFormRelations";

const ProjectFormRelation=()=>{

  const [search,setSearch]=useState("");
  const [isActive,setIsActive]=useState("");
  const [page,setPage]=useState(1);
  const [formSearch,setFormSearch]=useState("");

  const [isOpen,setIsOpen]=useState(false);
  const [editData,setEditData]=useState(null);

  const [formData,setFormData]=useState({
    projectId:"",
    formId:"",
    pageId:"",
  });

  const toggle=()=>setIsOpen(!isOpen);

  const { forms }=useFbForms({
    limit:20,
    search:formSearch,
  });

  const { projects }=useProjects({
    limit:1000,
  });

  const { relations, pagination, loading, fetchRelations, createRelation, updateRelation, toggleStatus } = useProjectFormRelations({ search, isActive, page });

  const handleSubmit=async()=>{

    try{

      const selectedForm=forms.find((f)=>f._id===formData.formId);

      const payload={
        ...formData,
        pageId:selectedForm?.pageId,
      };

      if(editData){

        await updateRelation(editData._id,payload);

        toast.success("Relation Updated");

      }else{

        await createRelation(payload);

        toast.success("Relation Created");
      }

      toggle();

      setEditData(null);

      setFormData({
        projectId:"",
        formId:"",
        pageId:"",
      });

    }catch(err){

      toast.error(err?.response?.data?.error||err?.message);
    }
  };

  return(
    <div className="page-content">

      <Breadcrumbs
        title="CRM"
        breadcrumbItem="Project Routing"
      />

      <Card>

        <CardBody>

          <Row className="g-3 align-items-end mb-3">

            <Col xs={12} md={4}>
              <Input
                placeholder="Search Relation"
                value={search}
                onChange={(e)=>{
                  setSearch(e.target.value);
                  setPage(1);
                }}
              />
            </Col>

            <Col xs={12} sm={6} md={3}>
              <Input
                type="select"
                value={isActive}
                onChange={(e)=>{
                  setIsActive(e.target.value);
                  setPage(1);
                }}
              >
                <option value="">All Status</option>
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </Input>
            </Col>

            <Col xs={12} sm={6} md={5}>
              <div className="d-flex justify-content-md-end justify-content-start gap-2">
                <Button
                  color="soft-secondary"
                  onClick={fetchRelations}
                  disabled={loading}
                  title="Refresh Relations"
                >
                  <i className={`mdi mdi-refresh me-1 ${loading ? "mdi-spin" : ""}`}></i> Refresh
                </Button>
                <Button
                  color="primary"
                  onClick={()=>{
                    setEditData(null);
                    setFormData({
                      projectId:"",
                      formId:"",
                      pageId:"",
                    });
                    toggle();
                  }}
                >
                  Add Relation
                </Button>
              </div>
            </Col>

          </Row>

          <Table bordered hover responsive>

            <thead>
              <tr>
                <th>Form</th>
                <th>Project</th>
                <th>Status</th>
                <th>Toggle</th>
                <th>Created</th>
                <th>Updated</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>

              {relations.map((r)=>(
                <tr key={r._id}>

                  <td>{r?.formId?.formName}</td>

                  <td>{r?.projectId?.projectName}</td>

                  <td>
                    <Badge color={r?.isActive?"success":"danger"}>
                      {r?.isActive?"Active":"Inactive"}
                    </Badge>
                  </td>

                  <td>
                    <div className="d-flex align-items-center">
                      <input
                        id={`rule-status-${r._id}`}
                        type="checkbox"
                        switch="primary"
                        checked={r?.isActive}
                        onChange={(e)=>toggleStatus(r._id,e.target.checked)}
                      />
                      <label
                        htmlFor={`rule-status-${r._id}`}
                        data-on-label=""
                        data-off-label=""
                        className="mb-0"
                      />
                    </div>
                  </td>

                  <td>{new Date(r.createdAt).toLocaleString()}</td>

                  <td>{new Date(r.updatedAt).toLocaleString()}</td>

                  <td>
                    <Button
                      size="sm"
                      color="warning"
                      onClick={()=>{
                        setEditData(r);

                        setFormData({
                          projectId:r?.projectId?._id,
                          formId:r?.formId?._id,
                          pageId:r?.formId?.pageId,
                        });

                        toggle();
                      }}
                    >
                      Edit
                    </Button>
                  </td>

                </tr>
              ))}

            </tbody>

          </Table>

          <div className="d-flex justify-content-end gap-2">

            <Button
              disabled={page<=1}
              onClick={()=>setPage((prev)=>prev-1)}
            >
              Prev
            </Button>

            <Button disabled>
              {pagination.page} / {pagination.totalPages}
            </Button>

            <Button
              disabled={page>=pagination.totalPages}
              onClick={()=>setPage((prev)=>prev+1)}
            >
              Next
            </Button>

          </div>

        </CardBody>

      </Card>

      <Modal isOpen={isOpen} toggle={toggle} centered>

        <ModalHeader toggle={toggle}>
          {editData?"Edit Relation":"Add Relation"}
        </ModalHeader>

        <ModalBody>

          <FormGroup>
            <Label>Select Form</Label>
            <Select
              value={
                  formData.formId
                  ? {
                      value:formData.formId,
                      label:
                        forms.find(
                          (f)=>f._id===formData.formId
                        )
                        ? `${forms.find(
                            (f)=>f._id===formData.formId
                          )?.formName} (${forms.find(
                            (f)=>f._id===formData.formId
                          )?.pageName})`
                        : "Selected Form",
                    }
                  : null
                }
              onInputChange={(value,meta)=>{ if( meta.action==="input-change" ){ setFormSearch(value); } }}
              onChange={(selected)=>
                setFormData((prev)=>({
                  ...prev,
                  formId:selected?.value||"",
                }))
              }
              options={forms.map((f)=>({
                value:f._id,
                label:`${f.formName} (${f.pageName})`,
              }))}
              placeholder="Search Form"
              isClearable
            />
          </FormGroup>

          <FormGroup className="mt-3">
            <Label>Select Project</Label>
            <Select
              value={
                projects
                  .map((p)=>({
                    value:p._id,
                    label:p.projectName,
                  }))
                  .find((x)=>x.value===formData.projectId)||null
              }
              onChange={(selected)=>
                setFormData((prev)=>({
                  ...prev,
                  projectId:selected?.value||"",
                }))
              }
              options={projects.map((p)=>({
                value:p._id,
                label:p.projectName,
              }))}
              placeholder="Search Project"
            />
          </FormGroup>
          <div className="text-end mt-4">

            <Button color="primary" onClick={handleSubmit}>
              {editData?"Update Relation":"Create Relation"}
            </Button>

          </div>

        </ModalBody>

      </Modal>

    </div>
  );
};

export default ProjectFormRelation;